<template>
  <Card
    :class="$style.cardMarginBottom"
  >
    <HeadingMedium
      :class="$style.headerBorder"
      hasMargin
    >
      {{ registrationInfo.title }}
    </HeadingMedium>
    <ParagraphBody
      bodySize="large"
      hasMargin
      weight="normal"
    >
      <Grid>
        <GridItem
          :class="$style.gridMarginTopHeader"
          :gridSpan="12"
        >
          {{ registrationInfo.label.enterprises }}: {{ googleEmmEnterpriseObj.enterpriseName }}
        </GridItem>
        <GridItem
          :class="$style.gridMarginTop"
          :gridSpan="12"
        >
          {{ registrationInfo.label.clientID }}: {{ googleEmmEnterpriseObj.clientId }}
        </GridItem>
        <GridItem
          :class="$style.gridMarginTop"
          :gridSpan="12"
        >
          {{ registrationInfo.label.dateAndTime }}: {{ googleEmmEnterpriseObj.createdAt }}
        </GridItem>
        <GridItem
          :class="$style.gridMarginTop"
          :gridSpan="12"
        >
          {{ registrationInfo.label.status }}:
          <StatusBadge
            :class="$style.status"
            :status="statusBadgeStatus"
            :text="connectionStatus"
          />
          <span :class="$style.gridButtonRight">
            <IconButton
              :class="$style.connectionButton"
              hasOutline
              icon="filter"
              iconPosition="left"
              text="Test Connection"
              type="secondary"
              @click="handleTestConnection"
            />
            <ButtonSecondary
              text="Delete"
              type="error"
              @click="handleDeleteRegistration"
            />
          </span>
        </GridItem>
      </Grid>
    </ParagraphBody>
  </Card>
</template>

<script>
import {
  AndroidEmmConsts, ItemTypeConsts, StoreModuleMap,
} from 'client/util/Constants';
import {
  ButtonSecondary,
  Card,
  Grid,
  GridItem,
  HeadingMedium,
  IconButton,
  ParagraphBody,
  StatusBadge,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];

export default {
  name: 'GoogleEmmRegistrationInfo',

  components: {
    ButtonSecondary,
    Card,
    Grid,
    GridItem,
    HeadingMedium,
    IconButton,
    ParagraphBody,
    StatusBadge,
  },

  data: () => ({
    connectionStatus: 'CONNECTED',
    registrationInfo: AndroidEmmConsts.androidEmmRegistrationText,
    statusBadgeStatus: 'success',
  }),

  computed: {
    ...mapState(googleModule, [
      'googleEmmEnterpriseObj',
    ]),
  },

  methods: {
    ...mapActions(googleModule, [
      'getConnectionStatus',
    ]),

    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),

    handleDeleteRegistration() {
      this.$emit('delete-registration-click');
    },

    async handleTestConnection() {
      try {
        const data = await this.getConnectionStatus(this.googleEmmEnterpriseObj.enterpriseObjectId);
        this.connectionStatus = data.isConnected ? 'CONNECTED' : 'FAILED';
        this.statusBadgeStatus = data.isConnected ? 'success' : 'error';
      } catch {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'Unable to fetch the connection status',
        });
      }
    },
  },
};
</script>

<style module scoped>
.cardMarginBottom {
  margin-bottom: var(--jc-spacer);
}

.headerBorder {
  border-bottom: var(--jc-border);
  padding-bottom: var(--jc-spacer);
}

.status {
  display: inline;
}

.gridMarginTop {
  margin-top: var(--jc-spacer-small);
}

.gridMarginTopHeader {
  margin-top: var(--jc-spacer);
}

.gridButtonRight {
  display: inline-block;
  float: right;
}

.connectionButton {
  margin-right: 0.625rem;
  padding-bottom: 0.7rem;
  padding-top: 0.4rem;
}
</style>
